import type { Banner } from '../effect/schema/openapi/backend';

export enum ProductOrBannerType {
  Banner,
  Product,
}

/**
 * Generic over the product shape so this stays independent of any one
 * product-card type — `insertBannersIntoProducts` never reads a product
 * field, so nothing here needs to name one.
 */
export type ProductOrBanner<TProduct> =
  | {
      type: ProductOrBannerType.Banner;
      banners: readonly Banner[];
    }
  | {
      type: ProductOrBannerType.Product;
      product: TProduct;
    };
